import React from 'react'
import '../styles/article.css'

const EchoesCH8 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 8: The High Stakes Stage</h1>

            <p>The afternoon session was reserved for the largest schools, and everything about it
                felt grander—bigger costumes, bolder concepts, and a kind of energy that could
                barely be contained within the walls of the theater. This was the stage where Ebony’s
                choir from Mississippi would compete, followed by Tom’s division—the schools with
                over 3,000 students.</p>
            <p>As I flipped through the program, the weight of the competition settled over me.
                Three of the choirs were from California. Frank always had a theory about them.
                “California choirs don’t just perform—they produce,” he’d say, waving his hands for
                emphasis. “Their concepts are probably storyboarded for months in a movie studio.
                The parents? Oh, I guarantee some of them work in the industry. And their
                costumes? Designed for characters, not students. Their sets? Hollywood-level, not
                the plywood-and-glue creations we slap together in a gym.”</p>
            <p>I smiled to myself, hearing his voice in my head. As much as I missed him, it felt like
                he was still here, his commentary filling the quiet spaces between the performances.
                He wasn’t wrong. California choirs always brought a level of polish that seemed
                untouchable. But as I looked at the lineup, my hope flickered. Maybe this year would
                be different. Maybe a choir from the Midwest—or the South—would finally claim
                the title.</p>


            <p>The first choir, from Nebraska, took the stage in Confederate and Union soldier
                uniforms. Their theme was a Civil War narrative, ending with a powerful rendition
                of “The Battle Hymn of the Republic.” It was poignant, thoughtful even, but as Cora
                leaned over to whisper, “This feels more like a PBS special,” I had to stifle a laugh.
                Frank would’ve texted me something similar, probably “Not a winner.”</p>
            <p>Then it was time for Mississippi. Barbara sat up straighter, her eyes glued to the
                stage. The lights dimmed, and the theater fell silent. A single spotlight appeared,
                illuminating Ebony as she stepped forward. She wore a sleek, shimmering red gown
                that caught the light with every movement. Her opening notes of “Do You Wanna
                Dance?” were soft, almost hesitant, but within moments her voice soared, rich and
                soulful, filling the auditorium with a kind of magic that made the hairs on the back
                of my neck stand up.</p>
            <p>The performance unfolded like a kaleidoscope of sound and movement. The choir
                transitioned seamlessly into a medley of hits—“Celebrate” by Three Dog Night,
                “Dance With Me” by Orleans, and “Boogie Wonderland” by Earth, Wind & Fire. The
                energy was electric, and the crowd couldn’t sit still. Even I found myself tapping my
                foot, caught up in the rhythm.</p>

            <p>Then came Ebony’s solo, a breathtaking rendition of “I Could Have Danced All
                Night” from My Fair Lady. The spotlight returned, isolating her against a backdrop
                of glittering chandeliers. Her voice was pure, each note wrapped in emotion, and by
                the time she hit the final crescendo, the audience erupted into applause. Barbara
                clutched my arm, her eyes brimming with tears. “That’s my girl,” she whispered, her
                voice breaking.</p>
            <p>But the show wasn’t done. The choir launched into Van Halen’s “Dance the Night
                Away,” their movements synchronized with dazzling precision. Costumes changed
                in the blink of an eye—literally on stage—as dancers spun and props glided into
                place. It was mesmerizing, a display of artistry and athleticism that felt almost
                otherworldly.</p>
            <p>The performance ended with Donna Summer’s “Last Dance,” the choir’s voices
                blending in perfect harmony as mirror balls cast shimmering lights across the room.
                The crowd was on its feet before the final note even faded, clapping and cheering
                with an enthusiasm that felt almost primal. Barbara was beaming, her pride
                radiating like the spotlight that had once illuminated Ebony. “She has it,” she said
                softly. “That voice, that presence. She’s unstoppable.”</p>

            <p>The next choir, from Wisconsin, performed a Christmas-themed show. It was
                polished, yes, but it lacked the spark of Mississippi’s energy. Barbara leaned over.
                “Still doing their Christmas show in March? They must have rehearsal restrictions.”</p>
            <p>Cora added with a smirk, “Those costumes look like they came from a rental shop.
                Half of them don’t even fit.”</p>
            <p>The Illinois choir’s Bonnie and Clyde-themed performance was dark and artistic,
                but as Frank always said, “People want songs they know and love—something they
                can sing along to.” This show, while creative, felt too detached from the audience.</p>

            <p>And then came the California choir. Their theme was “Beach Blanket,” a tribute to
                surf music of the ’50s and ’60s. The stage exploded with color as bikinis, surfboards,
                and projections of classic beach movies filled the scene. The boys, bare-chested and
                impossibly fit, danced alongside girls in retro swimsuits, their choreography as
                seamless as the waves in their backdrop. The audience loved it, but the riskiness of
                the costumes and the lack of a ballad left me unsettled. Still, I could almost hear
                Frank’s voice: “California again.”</p>



        </div>
    )
}

export default EchoesCH8